<template>
  <el-container>
    <el-header>
      <div @click="outlogin" class="menu-left">Wigor网站管理系统V1.0</div>
      <el-button @click="outlogin" class="menu-right">退出</el-button>
      <el-select v-model="lang" placeholder="" @change="changLang" class="menu-right">
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>

    </el-header>
    <el-container>
      <!-- <el-aside>Aside</el-aside> -->
      <AsideView></AsideView>
      <el-main>
        <router-view>这是首页</router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AsideView from "../components/AsideView.vue";
import axios from "axios";
export default {
  name: "HomeView",
  data(){
    return{
      lang:'_cn',
      options: []
    }
  },
  components: { AsideView },
  created() {
    this.getLang();
  },
  methods:{
    getUserList(){
      axios.get('/api/Home/getLang.html').then((res)=>{
        // console.log(res.data)
        if(res.data.code == 701){
          window.sessionStorage.removeItem('token');
          this.$router.push({
            name:'login'
          })
        }
        this.lang = res.data.data
      })
    },
    getLang(){
      axios.get('/api/Base/getLang.html').then((res)=>{
        if(res.data.code == 200){
          this.options = res.data.data;
        }
      });
    },
    outlogin(){
      axios.get('/api/Login/outlogin.html').then((res)=>{
        if(res.data.code == 200) {
          window.sessionStorage.removeItem('token');
          this.$router.push({
            name:'login'
          })
        }
      })
    },
    changLang(val){
      axios.get('/api/Home/changeLang.html?lang='+val).then((res)=>{
        // console.log(res.data)
        if(res.data.code == 200) location.reload()
      })
    }
  },
  mounted() {
    this.getUserList();
  }
};
</script>
<style>
.menu-left{
  float: left;
}
.menu-right{
  float: right;
}
.el-header button{
  margin: 10px 0 10px 10px;
}
.el-header {
  /* background-color: #b3c0d1; */
  background-color: #373f41;
  /* color: #333; */
  color: #fff;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  /* background-color: #d3dce6; */
  color: #333;
  text-align: center;
  /* line-height: 200px; */
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  /* text-align: center;
  line-height: 160px; */
}
.category{
  display: inline-block;
}
.add{
  float: right;
}
</style>
